import { createRouter, createWebHistory, type RouteLocationNormalized } from 'vue-router';
import indexRoutes from '@/router/index.router.js';
import accountRoutes from '@/router/account.router.js';
import { useAuthStore } from '@/stores/authStore';
import { pageForRoute } from '@/navigation/areas';
import { isGateOpen } from '@/navigation/gates';
import errorRouter from '@/router/error.router';
import { installEntityRouteGuards } from '@/router/entityRoutes';
import { installAuthGuards } from '@/router/authGuards';
import { installAreaSpots } from '@/navigation/areaSpots';

const router = createRouter({
  history: createWebHistory(),
  routes: [
    ...indexRoutes,
    ...accountRoutes,
    ...errorRouter,
    {
      path: '/:pathMatch(.*)*',
      redirect: { name: 'not-found' }
    }
  ]
});

installAuthGuards(router);
installEntityRouteGuards(router);
// Each area remembers the last list or page you were on in it, for its icon.
installAreaSpots(router, () => useAuthStore().userData?.id);

// A page opens only when its gate in the area table is open: the same check
// that decides whether the sidebar shows it, so a link and its address cannot
// disagree. Developers pass every gate inside isGateOpen. A page with no gate,
// such as Profile, is open to everyone signed in.
router.beforeEach(async (to: RouteLocationNormalized) => {
  const page = pageForRoute(typeof to.name === 'string' ? to.name : '', to.path);
  if (!page || page.gate === null) {
    return;
  }
  const authStore = useAuthStore();
  if (!authStore.userData) {
    await authStore.loadUser();
  }
  if (!isGateOpen(page.gate)) {
    return { name: 'home' };
  }
});

export default router;
